<template>
  <div
    v-if="leadsTabStats.length > 0"
    class="md-size-100 md-small-size-100"
  >
    <group-card title="Brokers" icon="real_estate_agent" padded>
      <template slot="actions">
        <md-button
          class="md-icon-button md-primary md-simple new-app-button"
          @click="exportToCSV()"
        >
          <md-icon id="new-app-icon">file_download</md-icon>
              Download CSV
          <md-tooltip md-direction="top">Import Broker CSV</md-tooltip>
        </md-button>
      </template>
      <div data-app>
        <v-data-table
          :headers="leadRequestHeader"
          :items="leadsTabStats"
          item-key="broker_id"
          :items-per-page="15"
          class="elevation-0 lead_requests_table"
          :footer-props="{
            showFirstLastPage: true,
            firstIcon: 'first_page',
            lastIcon: 'last_page',
            prevIcon: 'skip_previous',
            nextIcon: 'skip_next'
          }"
          >
        </v-data-table>
      </div>
    </group-card>
  </div>
</template>
<script>
import filters from '../components/utils/filters'
import { GroupCard } from "@/components";

export default {
  components: {
    GroupCard
  },
  props: ['leadsTabStats'],
  data() {
    return {
      leadRequestHeader: [
        { text: 'Pod/s', value: 'pod_names', align: 'center' },
        { text: 'Broker Name', value: 'full_name', align: 'center' },
        { text: 'SQL Requested', value: 'sql_required_leads', align: 'center'},
        { text: 'SQL Consumed', value: 'sql_total_applications', align: 'center'},
        { text: 'SQL Spend', value: 'sql_total_amount', align: 'center'},
        { text: 'SQL ROI', value: 'sql_roi', align: 'center'},
        { text: 'MQL Requested', value: 'mql_required_leads', align: 'center'},
        { text: 'MQL Consumed', value: 'mql_total_applications', align: 'center'},
        { text: 'MQL Spend', value: 'mql_total_amount', align: 'center'},
        { text: 'MQL ROI', value: 'mql_roi', align: 'center'}
      ]
    }
  },
  methods: {
    ...filters,
    exportToCSV() {
      const headers = this.leadRequestHeader.map(header => header.text);
      const rows = this.leadsTabStats.map(item =>
        this.leadRequestHeader.map(header => item[header.value])
      );

      let csvContent = "data:text/csv;charset=utf-8,";
      csvContent += headers.join(",") + "\r\n";
      rows.forEach(row => {
        csvContent += row.join(",") + "\r\n";
      });

      // Encode the CSV content and trigger the download
      const encodedUri = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", "leads_requests.csv");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  },
  filters: {
    ...filters
  },
}
</script>
<style scoped lang="scss">
.lead_requests_table {
  table {
    td {
      text-align: center;
    }
  }
}
</style>
